var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cropper-container"},[_c('img',{ref:"image",attrs:{"src":_vm.image.url,"alt":_vm.image.title}})])
}
var staticRenderFns = []

export { render, staticRenderFns }